import React, { useEffect, useMemo, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Input,
  ListGroup,
  ListGroupItem,
  Badge,
  Row,
  Col,
} from "reactstrap";
import {
  FaSearch,
  FaTruck,
  FaTimes,
  FaCheck,
  FaMoneyBillWave,
  FaKeyboard,
} from "react-icons/fa";
import POSKeypadModal from "./POSKeypadModal";

const SupplierSelectModal = ({
  isOpen,
  toggle,
  suppliers = [],
  selectedSupplier,
  onSelect,
  onAddNew,
}) => {
  const [query, setQuery] = useState("");
  const [keypadOpen, setKeypadOpen] = useState(false);

  useEffect(() => {
    if (isOpen) setQuery("");
  }, [isOpen]);

  const filtered = useMemo(() => {
    const q = (query || "").toLowerCase().trim();
    if (!q) return suppliers;

    return suppliers.filter((s) =>
      (s.nom || s.entreprise || "").toLowerCase().includes(q)
    );
  }, [query, suppliers]);

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle} size="xl" centered className="pos-client-modal">
        <ModalHeader toggle={toggle} className="fw-bold">
          <FaTruck className="me-2" />
          Sélection Fournisseur
        </ModalHeader>

        <ModalBody className="p-3">
          {/* SEARCH */}
          <div className="d-flex gap-2 mb-3">
            <div className="flex-grow-1 position-relative">
              <Input
                type="text"
                value={query}
                readOnly
                inputMode="none"
                className="ps-5 py-2 rounded-3 fw-bold pos-nokeyboard"
                placeholder="Rechercher fournisseur..."
                onClick={() => setKeypadOpen(true)}
              />

              <FaSearch
                style={{
                  position: "absolute",
                  left: 16,
                  top: "50%",
                  transform: "translateY(-50%)",
                  opacity: 0.7,
                }}
              />

              <Button
                type="button"
                color="light"
                className="position-absolute top-50 translate-middle-y border rounded-3"
                style={{ right: 10 }}
                onClick={() => setKeypadOpen(true)}
              >
                <FaKeyboard />
              </Button>
            </div>

            {onAddNew && (
              <Button color="primary" className="fw-bold px-3" onClick={onAddNew}>
                + Nouveau
              </Button>
            )}

            <Button
              color="secondary"
              outline
              className="fw-bold px-3"
              onClick={() => setQuery("")}
              disabled={!query}
            >
              <FaTimes className="me-2" />
              Effacer
            </Button>
          </div>

          {/* SELECTED SUPPLIER VIEW */}
          {selectedSupplier && (
            <div className="p-3 mb-3 rounded-4 bg-light border">
              <Row>
                <Col md={6}>
                  <div className="fw-bold">
                    Fournisseur choisi :{" "}
                    <span className="text-primary">
                      {selectedSupplier.nom || selectedSupplier.entreprise}
                    </span>
                  </div>
                </Col>
                <Col md={6} className="text-end">
                  <Badge color="success" pill>
                    <FaCheck className="me-1" />
                    Sélectionné
                  </Badge>
                </Col>
              </Row>
            </div>
          )}

          {/* LIST */}
          <ListGroup style={{ maxHeight: "70vh", overflowY: "auto" }}>
            {filtered.length === 0 ? (
              <div className="text-center text-muted py-5">
                Aucun fournisseur trouvé
              </div>
            ) : (
              filtered.map((s) => {
                const active = selectedSupplier?.id === s.id;

                return (
                  <ListGroupItem
                    key={s.id}
                    action
                    onClick={() => {
                      onSelect(s);
                      toggle();
                    }}
                    className={`p-3 rounded-4 mb-2 border ${
                      active ? "border-primary" : ""
                    }`}
                    style={{
                      cursor: "pointer",
                      background: active ? "#eef5ff" : "white",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <div style={{ fontSize: 18, fontWeight: 800 }}>
                        {s.nom || s.entreprise}
                      </div>

                      {active && (
                        <Badge color="primary" pill>
                          <FaCheck className="me-1" />
                          OK
                        </Badge>
                      )}
                    </div>

                    <div className="mt-2 text-muted" style={{ fontSize: 14 }}>
                      <FaMoneyBillWave className="me-2" />
                      Téléphone : {s.telephone1 || "-"}
                    </div>
                  </ListGroupItem>
                );
              })
            )}
          </ListGroup>

          <div className="d-flex justify-content-end mt-3">
            <Button
              color="danger"
              outline
              className="fw-bold"
              onClick={() => {
                onSelect(null);
                toggle();
              }}
            >
              Désélectionner fournisseur
            </Button>
          </div>
        </ModalBody>
      </Modal>

      {/* POS KEYPAD */}
      <POSKeypadModal
        isOpen={keypadOpen}
        toggle={() => setKeypadOpen(false)}
        value={query}
        onChange={(val) => setQuery(val)}
        onSearch={() => setKeypadOpen(false)}
        title="Recherche Fournisseur"
      />
    </>
  );
};

export default SupplierSelectModal;
